var _rect, _text, _text2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProbeFig2PromptsLiveOnce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 500",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 500,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The 1.1.0 refactor: every prompt lives exactly once")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Before, the full run carried paraphrases that drifted from the single-lens prompts. After, both launch the same agent.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 110,
    width: 520,
    height: 330,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 146,
    fontSize: 12,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#B45309"
  }, "BEFORE 1.1.0"), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 168,
    width: 200,
    height: 56,
    rx: 8,
    fill: "#FDF6EC",
    stroke: "#D9A441",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 192,
    fontSize: 12.5,
    fontFamily: "ui-monospace, monospace",
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "/probe:go"), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 210,
    fontSize: 10.5,
    fill: "#B45309",
    textAnchor: "middle"
  }, "carries a paraphrase of all six"), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 248,
    width: 200,
    height: 56,
    rx: 8,
    fill: "#FDF6EC",
    stroke: "#D9A441",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 272,
    fontSize: 12.5,
    fontFamily: "ui-monospace, monospace",
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "/probe:assume"), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 290,
    fontSize: 10.5,
    fill: "#B45309",
    textAnchor: "middle"
  }, "carries its own full prompt"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 240,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "two versions of"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 257,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "the same lens,"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 274,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#B45309"
  }, "free to drift apart"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 356,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "the full run and the single-lens run"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 372,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "could apply different questions"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 388,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "to the same document"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 616,
    y: 110,
    width: 536,
    height: 330,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 146,
    fontSize: 12,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#16A34A"
  }, "AFTER 1.1.0"), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 168,
    width: 170,
    height: 46,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#9CB3A6",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 725,
    y: 196,
    fontSize: 12.5,
    fontFamily: "ui-monospace, monospace",
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "/probe:go"), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 238,
    width: 170,
    height: 46,
    rx: 8,
    fill: "#F7FAF8",
    stroke: "#9CB3A6",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 725,
    y: 266,
    fontSize: 12.5,
    fontFamily: "ui-monospace, monospace",
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "/probe:assume"), /*#__PURE__*/React.createElement("text", {
    x: 725,
    y: 316,
    fontSize: 10.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "commands are thin"), /*#__PURE__*/React.createElement("text", {
    x: 725,
    y: 330,
    fontSize: 10.5,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "argument parsers"), /*#__PURE__*/React.createElement("g", {
    stroke: "#16A34A",
    strokeWidth: 1.4,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810 191 C 860 200, 880 220, 920 240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 261 C 860 258, 880 252, 920 250"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 924,
    y: 196,
    width: 204,
    height: 100,
    rx: 10,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 1026,
    y: 228,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "agents/challenge-"), /*#__PURE__*/React.createElement("text", {
    x: 1026,
    y: 246,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "assumptions.md"), /*#__PURE__*/React.createElement("text", {
    x: 1026,
    y: 270,
    fontSize: 11,
    fill: "#16A34A",
    textAnchor: "middle",
    fontWeight: 600
  }, "the one prompt"), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 356,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "seven agents own the seven prompts,"), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 372,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "so the full run and the single-lens run"), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 388,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "apply identical questions, always"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProbeFig2PromptsLiveOnce);
export default __webpack_public_path__ + "static/media/probe-fig2-prompts-live-once.2d893f06ba141d5352f73800a7d6382a.svg";
export { ForwardRef as ReactComponent };